import { GET_RESERVATION_PROVIDER_FAILURE, GET_RESERVATION_PROVIDER_REQUEST, GET_RESERVATION_PROVIDER_SUCCESS, GET_RESERVATION_PROVIDER_CLEAR, GetReservationProviderActionTypes, GetReservationProviderState } from './types';

const defaultState: GetReservationProviderState = {
  isLoading: false,
  errorMessage: "",
};

export default function getReservationProvider(state = defaultState, action: GetReservationProviderActionTypes): GetReservationProviderState {
  switch (action.type) {
    case GET_RESERVATION_PROVIDER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_RESERVATION_PROVIDER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_RESERVATION_PROVIDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_RESERVATION_PROVIDER_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: undefined
      };
    default:
      return state;
  }
};
